export default "__VITE_ASSET__gSF1mP4F__"